angular
        .module('progressBar.components', [])
        .component('progressBar', {
            templateUrl: 'ng/components/progressBar/progressBar.html',
            bindings: {
                number: '=',
                stepindex: '=',
                virtualfirststep: '=',
				title: '@',
				demo: '='
            },
            controllerAs: 'progressBarCtrl',
            controller: function ($translate) {
				var self = this;
				this.demo = this.demo || false;
				self.$onInit = function () {
					this.totalsteps = [];
					for(var i = 0; i < this.number; i++){
						this.totalsteps.push(i);
					}

					if(self.stepindex== null){
						self.stepindex= -10000;
					}
				}
				/*
            	this.getNumber = function(position){
            		if(this != null
            			&& this.number != null){
            			if('before' == position){
            				if(this.stepindex > 0){
            					return new Array(this.stepindex - 1);
            				} else {
            					return new Array(0);
            				}
                		} else if('current' == position){
                			if((this.stepindex > 0
                				|| this.virtualfirststep)
                				&& this.stepindex <= this.number){
                				return new Array(1);
            				} else {
            					return new Array(0);
            				}
                		} else if('after' == position){
                			if(this.virtualfirststep && this.stepindex == 0){
                				return new Array(this.number -1);
                			}
                			
                			if(this.stepindex > this.number){
                				return new Array(0);
                			} else {
                				return new Array(this.number - this.stepindex);
                			}
                		}
            		}
            		return new Array(1);
				}*/
            		
            }
        });